import { Form, Popup } from 'devextreme-react';
import {
  ButtonItem,
  ButtonOptions,
  GroupItem,
  Label,
  RequiredRule,
  SimpleItem,
} from 'devextreme-react/form';
import React, { useEffect, useRef, useState } from 'react';
import '../../assets/bulk-modal.scss';
import { useTranslation } from '../../contexts/translation';
import { CapacityCategory } from '../../types/capacityCategory.types';
import { DataGridActionType } from '../../types/dataGridActionTypes';
import './TasksBulkEditModal.scss';

type Props = {
  data: any;
  isVisible: boolean;
  capacityCategories?: Array<CapacityCategory>;
  mutate?: () => void;
  onClose: () => void;
  onSubmit: (data: any, actionType: DataGridActionType) => void;
  actionType: DataGridActionType;
};

/**
 * Modalová komponent pro vytváření/editaci záznamů typu Work Activity Group v datagridu
 */
export default function WorkActivityGroupModal({
  isVisible,
  onClose,
  capacityCategories,
  data,
  actionType,
  onSubmit,
}: Props) {
  const { translate } = useTranslation();
  const transFormName = 'WorkActivityGroup.List';
  const formRef = useRef<Form>(null);

  const [formData, setFormData] = useState<any>({});

  useEffect(() => {
    setFormData({ ...data, ...(actionType === DataGridActionType.Insert && { visible: true }) });
  }, []);

  return (
    <Popup
      visible={isVisible}
      dragEnabled={false}
      closeOnOutsideClick={false}
      onHiding={onClose}
      showTitle
      title={translate!('Work activity group', transFormName)}
      width={'auto'}
      height={'auto'}
    >
      <form
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(formData, actionType);
        }}
      >
        <Form
          formData={formData}
          showColonAfterLabel={true}
          showValidationSummary={true}
          ref={formRef}
        >
          <GroupItem>
            <GroupItem>
              <SimpleItem dataField="name" editorType="dxTextBox">
                <Label text={translate!('Name', transFormName)} />
                <RequiredRule message={translate!('Name is required', transFormName)} />
              </SimpleItem>
            </GroupItem>
            <SimpleItem
              dataField="capacityCategoryId"
              editorType="dxSelectBox"
              editorOptions={{
                items: capacityCategories,
                valueExpr: 'id',
                displayExpr: 'name',
                width: 300,
              }}
            >
              <Label text={translate!('Capacity category', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            <SimpleItem dataField="visible" editorType="dxCheckBox">
              <Label text={translate!('Visible', transFormName)} />
            </SimpleItem>
          </GroupItem>
          <GroupItem colCount={4}>
            <GroupItem colSpan={2}></GroupItem>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'normal'}
                text={translate!('Save', '')}
                useSubmitBehavior
              />
            </ButtonItem>
            <ButtonItem>
              <ButtonOptions
                width={'100%'}
                type={'normal'}
                text={translate!('Close', '')}
                onClick={onClose}
              />
            </ButtonItem>
          </GroupItem>
        </Form>
      </form>
    </Popup>
  );
}
